import React, { Component } from 'react'
import {
  getProductListByCategory,
  getFullHoldings,
  getFund,
} from '../FundDetails/Data/FundDetailsDataSource.js'
import { INTERVAL_FUND } from '../FundDetails/Helpers/FundTypes.js'
import { getUrlParameter } from '../../global/data/url.js'
import { init } from '../../global/authentication/secure-link-manager.js'
import { setFundGroupProductTypeAndFundPath } from '../FundDetails/Data/FundTypes.js'
import { showAlertBanner } from '../AlertBanner/index.js'
import { STATUS_ERROR } from '../AlertBanner/Constants.js'
import {
  ERROR_MESSAGE_TITLE,
  FUND_DETAILS_ERROR_MESSAGE_TEXT,
} from '../../spa/components/investmentProducts/helpers/ErrorMessages.js'
import { isEtf } from '../FundDetails/Helpers/CheckProductType.js'
import FundHeaderMain from '../FundDetails/Modules/FundHeader/FundHeaderMain.jsx'
import FundHeaderMessage from '../FundDetails/Modules/FundHeader/FundHeaderMessage.jsx'
import FullHoldingsDetails from './FullHoldingsDetails.jsx'
import './index.css'
import FundViewer from '../FundDetails/Modules/MutualFundViewer/FundViewer.jsx'
import { setMeta } from '../FundDetails/Helpers/Meta.js'
import Loader from '../FundDetails/Modules/Shared/Loader.jsx'
import { triggerDigitalData } from '../FundDetails/Helpers/Analytics.js'
import { fetchTooltipData } from '../Tooltip/tooltipUtil.js'

class FullHoldings extends Component {
  constructor(props) {
    super(props)

    this.state = {
      fund: null,
      productList: null,
      fullHoldings: null,
    }
  }

  _getFullHoldingsData(fullHoldings) {
    const fullHoldingsData =
      fullHoldings &&
      (fullHoldings?.value?.holdingDetail ||
        fullHoldings?.value?.etfHoldingDetail ||
        fullHoldings?.value?.productHoldingDetail)

    if (
      fullHoldingsData?.fullHoldings?.length > 0 ||
      fullHoldingsData?.holdings?.etfHoldings?.length > 0 ||
      fullHoldingsData?.productFullHoldings?.length > 0
    ) {
      return fullHoldingsData
    }

    return null
  }

  async _updateFundData(fund, productList, cusip) {
    // because this is a full holdings endpoint, there is no conditional for hiding a full holdings fund.
    if (cusip) {
      let dataType = ''
      if (fund.fundGroup === INTERVAL_FUND) {
        dataType = 'ProductFullHoldings'
      } else {
        dataType = isEtf(fund.miscellaneousDetails)
          ? 'ETFFullHoldings'
          : 'FullHoldings'
      }
      const fullHoldings = await getFullHoldings(cusip, dataType)

      triggerDigitalData(cusip, fund, 'Full Holdings')

      this.setState({
        fund,
        productList,
        fullHoldings,
      })
    } else {
      this.setState({
        fund,
        productList,
      })
    }
  }

  async componentDidMount() {
    const cusip = getUrlParameter('cusip')

    const _fund = await getFund(cusip)
    await fetchTooltipData()

    if (_fund && !_fund.error) {
      setFundGroupProductTypeAndFundPath(_fund)

      const _productList = await getProductListByCategory(_fund.productType)

      if (_productList && !_productList.error) {
        this._updateFundData(_fund, _productList, cusip)

        setMeta(_fund, 'Full Holdings')
      }
    } else {
      showAlertBanner({
        status: STATUS_ERROR,
        title: ERROR_MESSAGE_TITLE,
        text: FUND_DETAILS_ERROR_MESSAGE_TEXT,
      })
    }
  }

  componentDidUpdate() {
    init()
  }

  render() {
    const { fund, fullHoldings, productList } = this.state
    const isShortTermFund = fund
      ? fund.miscellaneousDetails.layoutID === '19'
      : false
    const fullHoldingDetail = this._getFullHoldingsData(fullHoldings)
    const styling = {
      inner: 'Card-body u-padding0',
      header: 'u-marginTop6gu',
      table: 'u-paddingTop3gu u-paddingBottom6gu',
    }

    return fund && this.state.fullHoldings ? (
      <div className="full-holdings-details" id="full-holdings-details">
        <FundViewer fund={fund} productList={productList} />
        <FundHeaderMain
          truncate={true}
          fund={fund}
          isEtf={isEtf(fund.miscellaneousDetails)}
          productList={productList}
        />
        <FundHeaderMessage fund={fund} />
        <FullHoldingsDetails
          fullHoldingDetail={fullHoldingDetail}
          isShortTermFund={isShortTermFund}
          fundGroup={fund.fundGroup}
          cusip={fund.cusip}
          styling={styling}
          isStandalone={true}
        />
      </div>
    ) : (
      <Loader />
    )
  }
}

export default FullHoldings
